import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    component: () =>
      import('@/page/index.vue')
  }, {
    path: '/app/share',
    name: 'app-share',
    component: () =>
      import('@/page/app/share.vue')
  }, {
    path: '/app/report',
    name: 'app-report',
    component: () =>
      import('@/page/app/report.vue')
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js